export const testId = {
  breedersSearch: 'breeders-search',
  breedersSearchBySelect: 'breeders-search-by-select',
  breedersSearchValueInput: 'breeders-search-value-input',

  breedersTable: 'breeders-table',
  breedersColumnActive: 'breeders-column-active',
  breedersColumnActiveLabel: 'breeders-column-active-label',
  breedersColumnActiveButton: 'breeders-column-active-button',

  breederAdminsTable: 'breeder-admins-table',
} as const;
